import Button from '@cobliteam/colib-ui/Button';
import { useTranslation } from '@cobliteam/i18n';
import { Dialog, Typography } from '@cobliteam/ui/components';
import slideCobliConecta from '@cobliteam/ui-business/components/dialogs/DialogRemoteConnection/assets/slide-cobli-conecta-qr-2x.png';
import { NUDGE_SURFACE } from '@cobliteam/ui-business/components/Nudge/nudgeSurface';
import { useState } from 'react';

interface CobliConectaSuggestionSlideProps {
  onAccept: (metadata?: Record<string, unknown>) => void;
  onDismiss: (reason?: string) => void;
}

const CobliConectaSuggestionSlide = ({ onAccept, onDismiss }: CobliConectaSuggestionSlideProps) => {
  const { t } = useTranslation('suggestions');
  const [qrOpen, setQrOpen] = useState(false);

  const handleAccept = () => {
    onAccept({ via: 'qr-code' });
    setQrOpen(true);
  };

  return (
    <>
      <div data-testid='cobli-conecta-suggestion' className='flex w-full flex-col gap-[9px]'>
        <Typography variant='description-title' className={NUDGE_SURFACE.title}>
          {t('cobli_conecta.title')}
        </Typography>

        <Typography variant='description-list-default' className={`text-start ${NUDGE_SURFACE.muted}`}>
          {t('cobli_conecta.description')}
        </Typography>

        <div className='flex items-center justify-between gap-2 pt-1'>
          <Button variant='ghost' size='sm' data-testid='cobli-conecta-suggestion-not-interested' onClick={() => onDismiss('not-interested')}>
            {t('cobli_conecta.not_interested')}
          </Button>
          <Button size='sm' onClick={handleAccept} data-testid='cobli-conecta-suggestion-cta'>
            {t('cobli_conecta.cta')}
          </Button>
        </div>
      </div>

      <Dialog
        open={qrOpen}
        onOpenChange={(isOpen) => {
          if (!isOpen) setQrOpen(false);
        }}
      >
        <Dialog.Content size='md'>
          <Dialog.Header className='justify-between'>
            <Dialog.Title>{t('cobli_conecta.qr_dialog.title')}</Dialog.Title>
            <Dialog.Description className='sr-only'>{t('cobli_conecta.qr_dialog.body')}</Dialog.Description>
            <Dialog.Close onClick={() => setQrOpen(false)} />
          </Dialog.Header>
          <Dialog.Body className='flex flex-col gap-4'>
            <Typography variant='description-list-default' color='secondary'>
              {t('cobli_conecta.qr_dialog.body')}
            </Typography>
            <div className='w-full overflow-hidden rounded-md'>
              <img src={slideCobliConecta} alt={t('cobli_conecta.qr_dialog.title')} className='w-full' data-testid='cobli-conecta-qr-image' />
            </div>
          </Dialog.Body>
        </Dialog.Content>
      </Dialog>
    </>
  );
};

export default CobliConectaSuggestionSlide;
